module.exports = "https://coursera_assets.s3.amazonaws.com/images/261d469116d65a8f1901dc161c414527.png";